import request from '@/utils/request'


// 查询商品自动扣减库存变动记录列表
export function listStockScriptLog(query) {
  return request({
    url: '/goods/stock/script/log/list',
    method: 'get',
    params: query
  })
}

// 查询商品自动扣减库存变动记录分页
export function pageStockScriptLog(query) {
  return request({
    url: '/goods/stock/script/log/page',
    method: 'get',
    params: query
  })
}

// 查询商品自动扣减库存变动记录详细
export function getStockScriptLog(data) {
  return request({
    url: '/goods/stock/script/log/detail',
    method: 'get',
    params: data
  })
}

// 新增商品自动扣减库存变动记录
export function addStockScriptLog(data) {
  return request({
    url: '/goods/stock/script/log/add',
    method: 'post',
    data: data
  })
}

// 修改商品自动扣减库存变动记录
export function updateStockScriptLog(data) {
  return request({
    url: '/goods/stock/script/log/edit',
    method: 'post',
    data: data
  })
}

// 删除商品自动扣减库存变动记录
export function delStockScriptLog(data) {
  return request({
    url: '/goods/stock/script/log/delete',
    method: 'post',
    data: data
  })
}
